let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("97IVb")).then(() => parcelRequire('5l3Aw'));